var map = {
	"./ic_mood_creative.png": 2356,
	"./ic_mood_focus.png": 4863,
	"./ic_mood_focused.png": 8347,
	"./ic_mood_positive.png": 6817,
	"./ic_mood_relax.png": 1181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7441;